import { onLocaleCompareSort } from '@/utils/common/dataSort';
export const ContactVarPrefix='Contact'
export const KeyVarPrefix='Key'
// a标签的href - 变量
export enum LINKVARIABLE {
  // 取消订阅
  unsubscribe = '{{unsubscribe_system}}',
  // 更新偏好
  updatePreference = '{{updatepreference_system}}',
  // value 值 取消订阅
  unsubscribeValue = 'unsubscribe',
  // 更新偏好
  updatePreferenceValue = 'updatePreference',
  // 浏览器打开
  viewEmailInBrowser = '{{view_email_browser}}',
  viewEmailInBrowserValue = 'viewEmailInBrowser',
  // 预览文本
  preview = '{{preview_text}}',
  previewVal = 'preview',

  // 二次确认
  optConfirm = '{{optinconfirmation_system}}',
  optConfirmValue = 'optConfirm',
  // 自定义
  customValue = 'custom',
  // 表单 href 前缀 formPrefixStr  结构是 {{{inline_form_随机字符}}
  formPrefixStr = '{{inline_form_',
  // 表单 href 后缀 formSuffixStr
  formSuffixStr = '}}',
  // 下拉选择
  LinkHrefOptions = [
    {
      hrefValue: '{{unsubscribe_system}}',
      radioValue: 'unsubscribe',
    },
    {
      hrefValue: '{{updatepreference_system}}',
      radioValue: 'updatePreference',
    },
    {
      hrefValue: '{{view_email_browser}}',
      radioValue: 'viewEmailInBrowser',
    },
    {
      hrefValue: '{{preview_text}}',
      radioValue: 'preview',
    },
    {
      hrefValue: '{{optinconfirmation_system}}',
      radioValue: 'optConfirm',
    },
  ],
}

// 图片缓存
export const localStoreKey = 'mailEditorUploadImgStore';

// 字体
export enum FontConfig {
  // google字体
  googleFontData = onLocaleCompareSort(
    [
      {
        name: 'Source sans-serif',
        value: 'Source sans-serif',
      },
      {
        name: 'Roboto Mono',
        value: 'Roboto Mono',
      },
      {
        name: 'Roboto Condensed',
        value: 'Roboto Condensed',
      },
      {
        name: 'Roboto',
        value: 'Roboto',
      },
      {
        name: 'Raleway',
        value: 'Raleway',
      },
      {
        name: 'Poiret One',
        value: 'Poiret One',
      },
      {
        name: 'Permanent Marker',
        value: 'Permanent Marker',
      },
      {
        name: 'Oswald',
        value: 'Oswald',
      },
      {
        name: 'Open Sans',
        value: 'Open Sans',
      },
      {
        name: 'Noto Sans JP',
        value: 'Noto Sans JP',
      },
      {
        name: 'Montserrat',
        value: 'Montserrat',
      },
      {
        name: 'Lobster',
        value: 'Lobster',
      },
      {
        name: 'Lato',
        value: 'Lato',
      },
      {
        name: 'Bitter',
        value: 'Bitter',
      },
      //   新增字体
      {
        name: 'Arvo',
        value: 'Arvo',
      },
      {
        name: 'Lora',
        value: 'Lora',
      },
      {
        name: 'Merriweather',
        value: 'Merriweather',
      },
      {
        name: 'Merriweather Sans',
        value: 'Merriweather Sans',
      },
      {
        name: 'Noticia Text',
        value: 'Noticia Text',
      },
      {
        name: 'Playfair Display',
        value: 'Playfair Display',
      },
      {
        name: 'Source Sans 3',
        value: 'Source Sans 3',
      },
      {
        name: 'Poppins',
        value: 'Poppins',
      },
    ],
    'name',
  ),
  // 自定义web字体 从远程拉取
  customWebFontData = [],
  // 默认字体
  defaultFontData = [
    { name: 'Arial', value: 'Arial' },
    { name: 'Arial Black', value: 'Arial Black' },
    { name: 'Brush Script MT', value: 'Brush Script MT' },
    { name: 'Comic Sans MS', value: 'Comic Sans MS' },
    { name: 'Courier New', value: 'Courier New' },
    { name: 'Georgia', value: 'Georgia' },
    { name: 'Helvetica', value: 'Helvetica' },
    { name: 'Impact', value: 'Impact' },
    { name: 'Lucida Sans Unicode', value: 'Lucida Sans Unicode' },
    { name: 'Tahoma', value: 'Tahoma' },
    { name: 'Times New Roman', value: 'Times New Roman' },
    { name: 'Trebuchet MS', value: 'Trebuchet MS' },
    { name: 'Verdana', value: 'Verdana' },
    { name: 'Noto Sans', value: 'Noto Sans' },
    { name: 'Source Han San', value: 'Source Han San' },
    { name: 'Alibaba PuHuiTi', value: 'Alibaba PuHuiTi' },
    { name: 'LXGW WenKa', value: 'LXGW WenKa' },
  ],
}

export const localWebFontStoreKey = 'mailEditorWebFontStore';
export const localColorStoreKey = 'mailEditorColorStore';
